<template>
  <Popover as="div" class="relative inline-block text-left">
    <PopoverButton
      class="relative pl-5 pr-10 min-w-[120px] inline-flex justify-start w-full py-2 border border-light-divider-border dark:border-dark-divider-border rounded-lg shadow-sm text-light-body-text dark:text-dark-body-text placeholder-common-grey focus:outline-none focus:ring-light-brand-blue dark:focus:ring-dark-brand-blue focus:border-light-brand-blue dark:focus:border-dark-brand-blue text-sm transition ease-in-out"
      @click="show_menu = true">
      <span>
        {{ `${$moment(selected_range.start).format("YYYY")}` }} ({{ $moment(selected_range.start).format("MM/DD") }} -
        {{ $moment(selected_range.end).format("MM/DD") }})</span>

      <span class="absolute inset-y-0 flex items-center pointer-events-none right-2">
        <ChevronDown class="w-5 h-5 text-common-grey" aria-hidden="true" />
      </span>
    </PopoverButton>

    <div>
      <transition
        enter-active-class="transition duration-100 ease-out"
        enter-from-class="transform scale-95 opacity-0"
        enter-to-class="transform scale-100 opacity-100"
        leave-active-class="transition duration-75 ease-in"
        leave-from-class="transform scale-100 opacity-100"
        leave-to-class="transform scale-95 opacity-0">
        <PopoverPanel
          as="div"
          :class="{ relative: relativePosition }"
          class="absolute left-0 z-20 mt-2 origin-top-left divide-y rounded-lg shadow-lg ring-1 ring-black ring-opacity-5 divide-light-divider-border dark:divide-dark-divider-border focus:outline-none">
          <div class="flex flex-col bg-white dark:bg-dark-screen-background">
            <div class="relative z-0 inline-flex shadow-sm rounded-lg gap-[1px] pb-0.5">
              <button
                type="button"
                class="px-2 bg-white border rounded-l-lg cursor-pointer border-light-divider-border dark:border-dark-divider-border dark:bg-dark-screen-background hover:z-10 focus:z-10 focus:outline-none focus:ring-1 text-light-body-text dark:text-dark-body-text hover:ring-light-brand-blue dark:hover:ring-dark-brand-blue hover:border-light-brand-blue dark:hover:border-dark-brand-blue"
                role="none"
                @click.prevent="getLastYear">
                <svg
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  viewBox="0 0 24 24"
                  width="24"
                  height="24"
                  class="vc-base-icon"
                  role="none">
                  <polyline points="15 18 9 12 15 6" role="none" />
                </svg>
              </button>
              <transition name="slide-fade">
                <div key="quartersDisplay" class="relative z-0 inline-flex shadow-sm rounded-lg gap-[1px] pb-0.5">
                  <div
                    :class="{ 'ring-1 ring-blue-light border-blue-light': 1 == selected_quarter }"
                    class="relative inline-flex items-center px-4 py-2 text-sm font-medium truncate transition ease-in-out bg-white border cursor-pointer border-light-divider-border dark:border-dark-divider-border dark:bg-dark-screen-background hover:z-10 focus:z-10 focus:outline-none focus:ring-1 text-light-body-text dark:text-dark-body-text hover:ring-light-brand-blue dark:hover:ring-dark-brand-blue hover:border-light-brand-blue dark:hover:border-dark-brand-blue"
                    @click="selectQuarter(1)">
                    <span>
                      {{ quarters[0].label }}
                    </span>
                  </div>
                  <div
                    :class="{ 'ring-1 ring-blue-light border-blue-light': 2 == selected_quarter }"
                    class="relative inline-flex items-center px-4 py-2 -ml-px text-sm font-medium truncate transition ease-in-out bg-white border cursor-pointer border-light-divider-border dark:border-dark-divider-border dark:bg-dark-screen-background hover:z-10 focus:z-10 focus:outline-none focus:ring-1 text-light-body-text dark:text-dark-body-text hover:ring-light-brand-blue dark:hover:ring-dark-brand-blue hover:border-light-brand-blue dark:hover:border-dark-brand-blue"
                    @click="selectQuarter(2)">
                    <span>
                      {{ quarters[1].label }}
                    </span>
                  </div>
                  <div
                    :class="{ 'ring-1 ring-blue-light border-blue-light': 3 == selected_quarter }"
                    class="relative inline-flex items-center px-4 py-2 -ml-px text-sm font-medium truncate transition ease-in-out bg-white border cursor-pointer border-light-divider-border dark:border-dark-divider-border dark:bg-dark-screen-background hover:z-10 focus:z-10 focus:outline-none focus:ring-1 text-light-body-text dark:text-dark-body-text hover:ring-light-brand-blue dark:hover:ring-dark-brand-blue hover:border-light-brand-blue dark:hover:border-dark-brand-blue"
                    @click="selectQuarter(3)">
                    <span>
                      {{ quarters[2].label }}
                    </span>
                  </div>

                  <div
                    :class="{ 'ring-1 ring-blue-light border-blue-light': 4 == selected_quarter }"
                    class="relative inline-flex items-center px-4 py-2 -ml-px text-sm font-medium truncate transition ease-in-out bg-white border cursor-pointer border-light-divider-border dark:border-dark-divider-border dark:bg-dark-screen-background hover:z-10 focus:z-10 focus:outline-none focus:ring-1 text-light-body-text dark:text-dark-body-text hover:ring-light-brand-blue dark:hover:ring-dark-brand-blue hover:border-light-brand-blue dark:hover:border-dark-brand-blue"
                    @click="selectQuarter(4)">
                    <span>
                      {{ quarters[3].label }}
                    </span>
                  </div>
                </div>
              </transition>
              <button
                type="button"
                class="px-2 bg-white border rounded-r-lg cursor-pointer border-light-divider-border dark:border-dark-divider-border dark:bg-dark-screen-background hover:z-10 focus:z-10 focus:outline-none focus:ring-1 text-light-body-text dark:text-dark-body-text hover:ring-light-brand-blue dark:hover:ring-dark-brand-blue hover:border-light-brand-blue dark:hover:border-dark-brand-blue"
                role="none"
                @click.prevent="getNextYear">
                <svg
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  viewBox="0 0 24 24"
                  width="24"
                  height="24"
                  class="vc-base-icon"
                  role="none">
                  <polyline points="9 18 15 12 9 6" role="none" />
                </svg>
              </button>
            </div>
            <div>
              <DatePicker
                v-model.range="selected_range"
                expanded
                :rules="rules"
                :is-dark="$store.state.ui.darkMode"
                class="bg-white dark:bg-dark-screen-background"
                is-expanded
                range />
            </div>
          </div>
        </PopoverPanel>
      </transition>
    </div>
  </Popover>
</template>

<script>
import { DatePicker } from "v-calendar"
import { Popover, PopoverButton, PopoverPanel } from "@headlessui/vue"
import { ChevronDown } from "lucide-vue-next"
export default {
  components: {
    Popover,
    PopoverButton,
    PopoverPanel,
    ChevronDown,
    DatePicker
  },
  props: { currentRange: null, relativePosition: null },
  emits: ["update:currentRange"],
  data() {
    return {
      rules: [
        {
          hours: 0,
          minutes: 0,
          seconds: 0,
          milliseconds: 0
        },
        {
          hours: 23,
          minutes: 59,
          seconds: 59,
          milliseconds: 999
        }
      ],
      show_menu: false,
      selected_quarter: 1,
      selected_range: { start: this.$moment().startOf("quarter").toDate(), end: this.$moment().endOf("quarter").toDate() },
      quarters: []
    }
  },
  computed: {},
  watch: {
    selected_range: {
      deep: true,
      handler() {
        this.$emit("update:currentRange", {
          start: this.$moment(this.selected_range.start).startOf("day"),
          end: this.$moment(this.selected_range.end).endOf("day")
        })
      }
    }
  },
  created() {
    if (this.currentRange && typeof this.currentRange == "string") {
      let current_range_list = this.currentRange?.replace("(", "").replace(")", "").split(",")
      this.selected_range = { start: this.$moment(current_range_list[0]).toDate(), end: this.$moment(current_range_list[1]).toDate() }
    } else {
      this.selected_range = { start: this.$moment().startOf("quarter").toDate(), end: this.$moment().endOf("quarter").toDate() }
    }
    // set the quarters based on the year range
    this.quarters = [1, 2, 3, 4].map((v) => {
      return {
        selected: v == 1,
        label: `Q${v} ${this.$moment(this.selected_range.start).format("YYYY")}`,
        start: this.$moment(this.selected_range.start).quarter(v).startOf("quarter"),
        end: this.$moment(this.selected_range.start).quarter(v).endOf("quarter")
      }
    })
    this.selected_quarter = this.$moment(this.selected_range.start).quarter()

    this.$emit("update:currentRange", {
      start: this.$moment(this.selected_range.start).startOf("day"),
      end: this.$moment(this.selected_range.end).endOf("day")
    })
  },
  methods: {
    getLastYear() {
      // move the select range to the last year first quarter
      this.selected_range = {
        start: this.$moment(this.selected_range.start).subtract(1, "year").startOf("quarter").toDate(),
        end: this.$moment(this.selected_range.end).subtract(1, "year").endOf("quarter").toDate()
      }

      this.quarters = [1, 2, 3, 4].map((v) => {
        return {
          selected: v == 1,
          label: `Q${v} ${this.$moment(this.selected_range.start).format("YYYY")}`,
          start: this.$moment(this.selected_range.start).quarter(v).startOf("quarter"),
          end: this.$moment(this.selected_range.start).quarter(v).endOf("quarter")
        }
      })

      this.selected_quarter = 1
    },
    getNextYear() {
      // move the select range to the next year first quarter
      this.selected_range = {
        start: this.$moment(this.selected_range.start).add(1, "year").startOf("quarter").toDate(),
        end: this.$moment(this.selected_range.end).add(1, "year").endOf("quarter").toDate()
      }

      this.quarters = [1, 2, 3, 4].map((v) => {
        return {
          selected: v == 1,
          label: `Q${v} ${this.$moment(this.selected_range.start).format("YYYY")}`,
          start: this.$moment(this.selected_range.start).quarter(v).startOf("quarter"),
          end: this.$moment(this.selected_range.start).quarter(v).endOf("quarter")
        }
      })

      this.selected_quarter = 1
    },

    selectQuarter(q) {
      this.selected_quarter = q
      this.show_menu = false
      this.selected_range = {
        start: this.$moment(this.selected_range.start).quarter(this.selected_quarter).startOf("quarter").toDate(),
        end: this.$moment(this.selected_range.start).quarter(this.selected_quarter).endOf("quarter").toDate()
      }
    }
  }
}
</script>
